import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/enviroments';
import { CompanyPortfolioAssignmentDTO, FilterCompanyAssignmentViewModel, MarkUnmarkCompanyAsFavoriteResponseDTO, PorfolioUser, PortfolioDTO, SelectedCompanyAssignmentToMarkUnmarkFavorite } from '../portfolio/interface/portfolio.interface';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { CompanyUserAssignment, FilterPagination } from '../files-clients/interface/company-client.interface';
import { ActionResponseDTO } from 'src/app/common/interfaces/action-result.interface';

@Injectable({
  providedIn: 'root',
})
export class PortfolioService {
  constructor(private http: HttpClient) {}

  getUserId(value: number) {
    const endpoint = `${environment.apiUrl}/DashboardFactoring/favorite/${value}`;
    return this.http.get<PorfolioUser>(endpoint);
  }

  getAssignCompaniesFromMyPortfolio(pagination: FilterPagination, filter: FilterCompanyAssignmentViewModel){
    let queryParams = new HttpParams()
    .set('page', pagination.page)
    .set('size', pagination.pageSize)
    .set('search', filter.search)
    .set('showFavorites', filter.favorite || '');
    const endpoint = `${environment.apiUrl}/user/portfolio/companies`;
    return this.http.get<PageResult<CompanyPortfolioAssignmentDTO>>(endpoint, {params: queryParams});
  }

  markAssignCompanyAsFavorite(request: SelectedCompanyAssignmentToMarkUnmarkFavorite) {
    const endpoint = `${environment.apiUrl}/portfolios/${request.portfolioId}/client/${request.companyId}/favorite/mark`;
    return this.http.patch<ActionResponseDTO<MarkUnmarkCompanyAsFavoriteResponseDTO>>(endpoint, null);
  }

  unmarkAssignCompanyAsFavorite(request: SelectedCompanyAssignmentToMarkUnmarkFavorite) {
    const endpoint = `${environment.apiUrl}/portfolios/${request.portfolioId}/client/${request.companyId}/favorite/unmark`;
    return this.http.patch<ActionResponseDTO<MarkUnmarkCompanyAsFavoriteResponseDTO>>(endpoint, null);
  }

  getMyPortfolios(): Observable<Array<PortfolioDTO>> {
    const endpoint = `${environment.apiUrl}/user/myPortfolios`;
    return this.http.get<Array<PortfolioDTO>>(endpoint);
  }

  assignCompanyToMyPortfolio(companyId: number): Observable<ActionResponseDTO<number>> {
    const endpoint = `${environment.apiUrl}/user/portfolio/company/${companyId}/assign`;
    return this.http.post<ActionResponseDTO<number>>(endpoint, null);
  }

  getInfoPortafolioCompany(companyId: number): Observable<CompanyUserAssignment | null>{
    const endpoint = `${environment.apiUrl}/portfolios/portafolioInfo/${companyId}`;
    return this.http.get<CompanyUserAssignment | null>(endpoint)
    .pipe(
     catchError(err => {
      return throwError(() => null)
     })
    )
  }

}
